import { create } from 'zustand';
import type { AuthBusinessSummary, AuthUser, LoginResponse } from '@koyomi/shared';

interface AuthState {
  status: 'booting' | 'anonymous' | 'authenticated';
  accessToken: string | null;
  user: AuthUser | null;
  businesses: AuthBusinessSummary[];
  businessId: string | null;
  setSession: (s: LoginResponse) => void;
  setBusiness: (id: string | null) => void;
  setAnonymous: () => void;
  clear: () => void;
}

const BIZ_KEY = 'koyomi.businessId';
function savedBusiness(): string | null {
  try { return localStorage.getItem(BIZ_KEY); } catch { return null; }
}

/** Access token só em memória; refresh em cookie httpOnly; negócio ativo persistido por conveniência. */
export const useAuthStore = create<AuthState>((set, get) => ({
  status: 'booting',
  accessToken: null,
  user: null,
  businesses: [],
  businessId: null,
  setSession: (s) => {
    const saved = get().businessId ?? savedBusiness();
    const businessId = s.businesses.some((b) => b.id === saved) ? saved : s.businesses.length === 1 ? s.businesses[0]!.id : null;
    set({ status: 'authenticated', accessToken: s.accessToken, user: s.user, businesses: s.businesses, businessId });
  },
  setBusiness: (id) => {
    try { if (id) localStorage.setItem(BIZ_KEY, id); else localStorage.removeItem(BIZ_KEY); } catch { /* ignore */ }
    set({ businessId: id });
  },
  setAnonymous: () => set({ status: 'anonymous', accessToken: null, user: null, businesses: [] }),
  clear: () => set({ status: 'anonymous', accessToken: null, user: null, businesses: [], businessId: null }),
}));

export function useActiveBusiness(): AuthBusinessSummary | null {
  const { businesses, businessId } = useAuthStore();
  return businesses.find((b) => b.id === businessId) ?? null;
}
